/**
 * Countries are stored as ISO 3166-1 alpha-2 codes and printed by name.
 * Names come from Intl (built into Node and every current browser), so no list of names is kept by hand.
 */
const CODES =
  "AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ " +
  "CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR " +
  "GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP " +
  "KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT " +
  "MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW " +
  "SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG " +
  "UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW";

export const COUNTRY_CODES: readonly string[] = CODES.split(" ");

/** U.S. territories: not "the United States" on a W-8BEN, but worth a second look. */
export const US_TERRITORIES: readonly string[] = ["AS", "GU", "MP", "PR", "UM", "VI"];

const cache = new Map<string, Intl.DisplayNames>();

export function countryName(code: string | null | undefined, locale = "en"): string {
  if (!code) return "";
  let dn = cache.get(locale);
  if (!dn) {
    dn = new Intl.DisplayNames([locale], { type: "region" });
    cache.set(locale, dn);
  }
  return dn.of(code) ?? code;
}

/** Options for a country picker: the `first` codes on top (e.g. India), then A–Z by name. */
export function countryOptions(first: string[] = [], locale = "en"): { value: string; label: string }[] {
  const rest = COUNTRY_CODES.filter((c) => !first.includes(c))
    .map((c) => ({ value: c, label: countryName(c, locale) }))
    .sort((a, b) => a.label.localeCompare(b.label, locale));
  return [...first.map((c) => ({ value: c, label: countryName(c, locale) })), ...rest];
}
